export const EVENT_NAME = {
  VIEWED: "Education Video Viewed",
  PLAY_SUCCESS: "Education Video Play Successful",
  CLICK_PLAY: "Education Video Play Clicked",
  PAUSE: "Education Video Paused",
  COMPLETE: "Education Video 100pc Played",
  ERROR: "Education Video Play Error",
  LOAD_FAIL: "Education Video Load Failed"
};
